import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getActiveList = store => store[NAME].activeList;
export const getFinishedList = store => store[NAME].finishedList;
export const getParticipants = store => store[NAME].participants;
export const getCanViewStats = store => store[NAME].canViewStats;
export const getSessionTypes = store => store[NAME].sessionTypes;
export const getSpecificTrainingData = store => store[NAME].specificTrainingData;
export const getActivityData = store => store[NAME].activityData;
export const getResolutionData = store => store[NAME].resolutionData;
export const getQuestionData = store => store[NAME].questionData;
export const getTrainingStats = store => store[NAME].trainingStats;
export const getParticipantStats = store => store[NAME].participantStats;
export const getSpecificTrainingStats = store => store[NAME].specificTrainingStats;